import { ChevronDown, Menu, Play, Sparkles } from 'lucide-react'
import { mockBusiness } from '@/data/mockBusiness'
import { Avatar } from '@/components/ui/Avatar'
import styles from './TopBar.module.css'

interface TopBarProps {
  onMenuClick: () => void
}

export function TopBar({ onMenuClick }: TopBarProps) {
  return (
    <header className={styles.topbar}>
      <div className={styles.left}>
        <button
          type="button"
          className={styles.menuBtn}
          aria-label="Open menu"
          onClick={onMenuClick}
        >
          <Menu size={20} />
        </button>

        <button type="button" className={styles.businessSelector}>
          <Avatar name={mockBusiness.name} size="sm" />
          <span className={styles.businessName}>{mockBusiness.name}</span>
          <ChevronDown size={16} className={styles.chevron} />
        </button>
      </div>

      <div className={styles.right}>
        <button type="button" className={styles.tutorialsBtn}>
          <Play size={16} />
          <span>Tutorials</span>
        </button>
        <button type="button" className={styles.upgradeBtn}>
          <Sparkles size={16} />
          <span>Upgrade</span>
        </button>
        <Avatar name={mockBusiness.owner} size="md" />
      </div>
    </header>
  )
}
